import {
  Avatar,
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
} from '@mui/material'
import { useSwapContext } from '@plug-core/providers/SwapProvider'
import React, { type FC } from 'react'
import ICPSwapLogo from '@plug-core/assets/icons/icpswap.png'
import KongSwapLogo from '@plug-core/assets/icons/kongswap.png'
import OdinLogo from '@assets/icons/odin.webp'
import { SwapProvider } from '@plug-core/interfaces/swapInterface'
import BottomSheet from '@components/BottomSheet'

const SWAP_PROVIDER_LOGO_MAP = {
  [SwapProvider.ICPSWAP]: ICPSwapLogo,
  [SwapProvider.KONGSWAP]: KongSwapLogo,
  [SwapProvider.ODIN]: OdinLogo,
}

type Props = {
  visible: boolean
  onClose: () => void
}

export const SwapProviderSelect: FC<Props> = ({ visible, onClose }) => {
  const { quotes, selectedProvider, setManualProvider } = useSwapContext()

  const renderProviders = () => {
    return (
      <Stack component={List} spacing={1} px={2}>
        {quotes?.map(({ humanPrice, pair }) => {
          const isSelected = selectedProvider === pair.provider

          return (
            <Box key={pair.provider}>
              <ListItem
                key={pair.provider}
                onClick={() => {
                  setManualProvider(pair.provider)
                  onClose()
                }}
              >
                <ListItemIcon>
                  <Avatar src={SWAP_PROVIDER_LOGO_MAP[pair.provider]} />
                </ListItemIcon>
                <ListItemText primary={pair.provider} secondary={humanPrice.toFixed(8)} />
                <ListItemSecondaryAction>
                  <ListItemText
                    sx={{ textAlign: 'right' }}
                    secondaryTypographyProps={{
                      color: isSelected ? 'rainbow.green' : 'text.secondary',
                    }}
                    secondary={isSelected ? 'Selected' : 'Select'}
                  />
                </ListItemSecondaryAction>
              </ListItem>
              <Divider
                sx={{
                  borderColor: (theme) => theme.palette.background.default,
                }}
              />
            </Box>
          )
        })}
      </Stack>
    )
  }

  return (
    <BottomSheet visible={visible} onBackdropClick={onClose}>
      {renderProviders()}
    </BottomSheet>
  )
}
